<template>
  <v-card v-if="modelValue.exclusionSecuritySettingsDto" class="mt-4">
    <v-card-text>
      <div class="subtitle1">{{ $t("emailSettings.settingsTab.subjectLine") }}</div>
      <v-checkbox
        class="mt-4"
        v-model="localValue.exclusionSecuritySettingsDto.emailSubjectKeywordsEnabled"
        :disabled="disabled"
      >
        <template #label>
          <div class="body2">
            {{ $t("emailSettings.settingsTab.scanBypassLabel") }}
          </div>
        </template>
      </v-checkbox>
      <v-combobox
        v-model="localValue.exclusionSecuritySettingsDto.emailSubjectKeywords"
        clearable
        clear-icon="$x"
        class="mt-2 ml-7"
        variant="outlined"
        :placeholder="$t('emailSettings.settingsTab.emailSubjectKeywordsPlaceHolder')"
        :aria-label="$t('emailSettings.settingsTab.emailSubjectKeywordsPlaceHolder')"
        multiple
        :disabled="disabled || !localValue.exclusionSecuritySettingsDto.emailSubjectKeywordsEnabled"
      >
        <template v-slot:chip="{ props, item }">
          <v-chip
            v-bind="props"
            :closable="true"
            :disabled="
              disabled || !localValue.exclusionSecuritySettingsDto.emailSubjectKeywordsEnabled
            "
            variant="flat"
            size="default"
            color="indigo-faint"
            close-icon="$closeCircle"
            :text="item.title"
          >
            <div class="d-flex align-center">
              <span class="ml-1 mr-2">{{ item.title }}</span>
            </div>
          </v-chip>
        </template>
      </v-combobox>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, toRefs, type PropType } from "vue";
import type { EmailSecuritySettings } from "@/_store/email-security/email-settings.module.ts";

import { useTwoWayBinding } from "@/composables/useTwoWayBinding.ts";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as PropType<EmailSecuritySettings>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const localValue = useTwoWayBinding(modelValue, (value) => {
      emit("update:modelValue", value);
    });

    return {
      localValue,
    };
  },
});
</script>
